import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { useParams } from "react-router-dom";
import BaseRating from "../../../components/ui/BaseRating";
import FeedbackListingModal from "./components/FeedbackListingModal";
import { fetchUserMarketplaceRating } from "../../../services/api/feedback";
import { useQuery } from "@tanstack/react-query";

const Rating = () => {
  const { id: userId } = useParams();
  const { data: ratingData } = useQuery({
    queryKey: ["marketplaceRating", userId],
    queryFn: () => fetchUserMarketplaceRating(userId),
    enabled: !!userId,
  });
  const [isFeedbackListingModalOpen, setIsFeedbackListingModalOpen] = useState(false);
  return (
    <>
      <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
        <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
          <h6 className="text-dark font-normal">Rating</h6>
        </div>
        <div>
          <div className="sm:flex items-center">
            <BaseRating rating={ratingData?.data.rating} size="medium" />
            <p className="sm:ml-3">Market Place</p>
            <p
              className="text-primary sm:ml-3 cursor-pointer"
              onClick={() => setIsFeedbackListingModalOpen(true)}
            >
              See All {ratingData?.data.count} Ratings
            </p>
          </div>

          <div className="xl:flex items-center mt-6">
            <p className="text-secondary font-normal mr-4 xl:mb-0 mb-3">Endorsements:</p>
            <div className="flex flex-wrap xl:gap-8 gap-4">
              <div className="flex bg-light px-3 py-1.5 rounded-md">
                <p>Communication</p>
                <p className="ml-8">{ratingData?.data?.likedOptions.CLEAR_COMMUNICATION || 0}</p>
              </div>
              <div className="flex bg-light px-3 py-1.5 rounded-md">
                <p>Professionalism</p>
                <p className="ml-8">{ratingData?.data?.likedOptions.PROFESSIONALISM || 0}</p>
              </div>
              <div className="flex bg-light px-3 py-1.5 rounded-md">
                <p>Problem solving</p>
                <p className="ml-8">{ratingData?.data?.likedOptions.PROBLEM_SOLVING || 0}</p>
              </div>
              <div className="flex bg-light px-3 py-1.5 rounded-md">
                <p>Preparedness</p>
                <p className="ml-8">{ratingData?.data?.likedOptions.PREPAREDNESS || 0}</p>
              </div>
            </div>
          </div>
        </div>
      </BaseCard>

      {isFeedbackListingModalOpen && (
        <FeedbackListingModal
          open={isFeedbackListingModalOpen}
          close={setIsFeedbackListingModalOpen}
        />
      )}
    </>
  );
};

export default Rating;
